<template>
  <div class="flash-sale" v-if="flashSaleActGoods.list.length">
    <div class="goods"
      v-for="(item, index) in flashSaleActGoods.list" :key="index"
      @click="jumpDetails(item)"
    >
      <div class="goods-img">
        <img :src="item.image[0]" alt="商品图" />
        <div class="tag" v-show="actConfig && actConfig.img">
          <img :src="actConfig.img" alt="">
        </div>
      </div>
      <div class="goods-info">
        <div class="goods-title van-ellipsis">{{ item.title }}</div>
        <div class="tags" v-if="item.tags && item.tags.length">
          <div class="tag" v-for="(tag, tagIndex) in item.tags" :key="tagIndex">{{ tag }}</div>
        </div>
        <div class="price">
          <div class="price-now">￥<span>{{ item.member_discount }}</span></div>
          <div class="price-old">日常价：￥{{ item.price }}</div>
        </div>
        <div class="total-num" :class="{
          'min-num': item.status === 2 || flashSaleActGoods.actInfo.status === 2,
        }">
          <div class="remainder"
            :style="{
                    width: `${
                      flashSaleActGoods.actInfo.status === 0
                      ? 100
                      : flashSaleActGoods.actInfo.status === 2
                      ? 0
                      : ((item.surplus / item.total).toFixed(2) * 100 > 80
                      ? 80
                      : (item.surplus / item.total).toFixed(2) * 100)}%`
            }"
          ></div>
          <div class="total-num-text" v-if="flashSaleActGoods.actInfo.status === 0 && item.surplus === 0">剩余{{item.surplus}}份</div>
          <div class="total-num-text" v-else-if="flashSaleActGoods.actInfo.status === 0">限量{{item.total}}份</div>
          <div class="total-num-text" v-else-if="flashSaleActGoods.actInfo.status === 1 && item.surplus === 0">今日已抢完</div>
          <div class="total-num-text" v-else-if="flashSaleActGoods.actInfo.status === 1 && item.status === 1">仅剩{{item.surplus}}份</div>
        </div>
        <div class="btn" :class="{
          'bg0': flashSaleActGoods.actInfo.status === 0,
          'bg1': flashSaleActGoods.actInfo.status === 1,
          'bg2': flashSaleActGoods.actInfo.status === 2,
          'filter-gray': (item.surplus === 0 && flashSaleActGoods.actInfo.status === 1)
        }">
          {{(flashSaleActGoods.actInfo.status === 2)
            ? `已结束`
            : (flashSaleActGoods.actInfo.status === 1)
            ? `立即购买`
            : `未开始` }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'flash-sale',
  props: {
    actConfig: {
      type: Object
    }
  },
  data () {
    return {
      flashSaleActGoods: {
        actInfo: null,
        list: []
      }
    }
  },
  created () {
    this.getFlashSaleActGoods()
  },
  activated () {
    this.getFlashSaleActGoods()
  },
  methods: {
    jumpDetails (item) {
      if (this.flashSaleActGoods.actInfo.status === 2) {
        this.$toast('今日活动已结束')
        return
      } else if (this.flashSaleActGoods.actInfo.status === 0) {
        this.$toast('今日活动还未开始')
        return
      }
      if (item.surplus === 0) {
        this.$toast('今日已抢完')
        return
      }
      if (this.flashSaleActGoods.phone) {
        let url = 'https://hymall.wanyuenet.com/appletLoding?appletUrl=pagesMall%2Flogin%2FauthLogin'
        let ap = 'baogang'
        let ch = process.env.VUE_APP_CURRENTMODE === 'prod' ? 'su2l829313220091' : 'su2e054872509710'
        let rq = `/pagesMall/details/details?payType=shop_coupon&skuid=${item.coupon_id}&goodsType=1&source=5gm&sid=${item.shop_id}&actCode=${this.actConfig.aid}`
        let tk = this.flashSaleActGoods.phone
        // console.log(`ap=${ap}&rq=${encodeURIComponent(rq)}&ch=${ch}&tk=${tk}`)
        location.href = `${url}&ap=${ap}&ch=${ch}&rq=${encodeURIComponent(rq)}&tk=${tk}`
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    async getFlashSaleActGoods () { // 获取秒杀专区商品
      const res = await this.$axios.get(`api/goods/activityGoodsList/${this.actConfig.aid}/1/10`)
      if (res.status === 200) {
        const { code, data } = res.data
        if (code === 0) {
          this.flashSaleActGoods = data
        }
      }
    }
  }
}

</script>
<style lang="less" scoped>
.goods{
  width: 7.02rem;
  height: 2.2rem;
  background: #FFFFFF;
  border-radius: .1rem;
  display: flex;
  padding: 0.18rem;
  box-sizing: border-box;
  margin-bottom: .2rem;
  position: relative;
  &:last-child {
    margin-bottom: 0;
  }
  .goods-img{
    width: 1.84rem;
    height: 1.84rem;
    flex-shrink: 0;
    position: relative;
    .tag{
      position: absolute;
      left: 0;
      top: .15rem;
      width: .83rem;
      height: .23rem;
    }
  }
  .goods-info{
    width: 4.8rem;
    margin-left: 0.24rem;
    .goods-title{
      color: #28292C;
      font-size: .26rem;
      font-weight: 500;
      line-height: .37rem;
      letter-spacing: 1px;
    }
    .tags{
      display: flex;
      align-items: center;
      margin-top: .13rem;
      .tag{
        margin-right: .1rem;
        height: .38rem;
        line-height: .38rem;
        font-size: .22rem;
        color: #D59865;
        background: #FFF2E7;
        border-radius: .08rem;
        border: 1px solid #D59865;
        padding: 0 .12rem;
      }
    }
    .price{
      display: flex;
      align-items: center;
      margin-top: .13rem;
      .price-now{
        color: #FF5555;
        font-size: .24rem;
        span{
          font-size: .32rem;
        }
      }
      .price-old{
        color: #ABABAB;
        font-size: .22rem;
        margin-left: .18rem;
      }
    }
    .total-num{
      width: 2.44rem;
      height: .26rem;
      background: #FFDFDF;
      border-radius: .13rem;
      position: relative;
      margin-top: .13rem;
      overflow: hidden;
      &.min-num{
        color: #A1A1A1;
        background: #EAEAEA;
      }
    }
    .remainder{
      height: .26rem;
      background-color: #FF4F4F;
      border-radius: .13rem;
      &.min-num{
        background: #EAEAEA;
      }
    }
    .total-num-text{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      height: .26rem;
      line-height: .26rem;
      text-align: center;
      font-size: .2rem;
      color: #ABABAB;
    }
    .btn{
      width: 1.5rem;
      height: .52rem;
      line-height: .52rem;
      text-align: center;
      color: #fff;
      background: #FF5555;
      border-radius: .25rem;
      font-size: .26rem;
      font-weight: 500;
      position: absolute;
      right: .11rem;
      bottom: .17rem;
      &.bg0{
        background: #FFA655;
      }
      &.bg1{
        background: #FF5555;
      }
      &.bg2{
        background: #737373;
      }
    }
  }
}
</style>
